<template>
  <div class="content">
    <div class="box_7 flex-row">
      <div class="text-group_2 flex-col">
        <span class="paragraph_1">
          <p style="text-align: center;margin-bottom: 1em;">
            <strong
              ><span 
                >『最強三国～黄金城の決戦』 黄金城争覇戦イベント詳細</span
              ></strong
            >
          </p>
          <p>
            <strong
              ><span 
                ><span>一、</span></span
              ></strong
            ><strong
              ><span 
                >参加方法</span
              ></strong
            >
          </p>
          <p>
            <strong
              ><span 
                >&nbsp;</span
              ></strong
            >
          </p>
          <p>
            <span>1.</span
            ><span>参加対象</span>
          </p>
          <p>
            <strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                >サービスが開始した『最強三国～黄金城の決戦』 の</span
              ></strong
            ><strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                >1-23</span
              ></strong
            ><strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                >のサーバーが参加対象となります。</span
              ></strong
            ><strong></strong>
          </p>
          <p>
            <strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                >イベント期間中に</span
              ></strong
            ><strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                >1-23</span
              ></strong
            ><strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                >以外のサーバーはイベント対象外となります。</span
              ></strong
            ><strong></strong>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2.</span
            ><span>参加地域</span>
          </p>
          <p>
            <span 
              >本イベント開催地域は日本です。本イベン</span
            ><span>トの主催者は</span
            ><span 
              >GURU GAMES CO.,LIMITED</span
            ><span>となります。</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>3.</span
            ><span>参加資格</span>
          </p>
          <p>
            <span>1</span
            ><span>）</span
            ><span 
              >イベント期間中『最強三国～黄金城の決戦』のアカウントをお持ちの</span
            ><span>20</span
            ><span 
              >歳以上のプレイヤーであれば、どなたでも参加できます。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2</span
            ><span>）</span
            ><span>20</span
            ><span
              >歳未満または日本に在住してないのプレイヤーが通常通りにゲームを遊ぶことができますが、本イベントの賞品を受領できません。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <strong
              ><span 
                ><span>二、</span></span
              ></strong
            ><strong
              ><span 
                >イベント日程</span
              ></strong
            ><strong></strong>
          </p>
          <p>
            <strong
              ><span 
                >&nbsp;</span
              ></strong
            >
          </p>
          <p>
            <span>1.</span
            ><span
              >イベント開始時間：</span
            >
          </p>
          <p >
            <span 
              >『最強三国～黄金城の決戦』が正式リリースした後、</span
            ><span>1-23</span
            ><span>の</span
            ><span 
              >サーバーがそれぞれオーペンした時点です。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2.</span
            ><span 
              >イベント終了時間：</span
            >
          </p>
          <p >
            <span 
              >『最強三国～黄金城の決戦』が正式リリースした後、</span
            ><span>1-23</span
            ><span 
              >サーバーがオーペンした後の第</span
            ><span>8</span
            ><span>日の</span
            ><span>22</span
            ><span 
              >時をイベント終了時間とします。</span
            >
          </p>
          <p>
            <span>例：</span
            ><span>8</span
            ><span>サーバーは</span
            ><span>5</span
            ><span>月</span
            ><span>22</span
            ><span 
              >日にオーペンし、イベント終了時間が</span
            ><span>5</span
            ><span>月</span
            ><span>29</span
            ><span>日</span
            ><span>22</span
            ><span>時とします。</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>3.</span
            ><span 
              >イベント結果発表時間</span
            >
          </p>
          <p >
            <span 
              >イベントに参加した</span
            ><span>1-23</span
            ><span 
              >のサーバーがそれぞれイベント終了後、</span
            ><span>7</span
            ><span 
              >営業日以内に発表します。</span
            >
          </p>
          <p>
            <span>例：</span
            ><span>8</span
            ><span>サーバーは</span
            ><span>5</span
            ><span>月</span
            ><span>22</span
            ><span 
              >日がサービス開始し、イベント終了時間は</span
            ><span>5</span
            ><span>月</span
            ><span>29</span
            ><span>日</span
            ><span>22</span
            ><span 
              >時とし、イベント結果は</span
            ><span>6</span
            ><span>月</span
            ><span>7</span
            ><span 
              >日前に発表致します。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p >
            <strong
              ><span 
                ><span>三、</span></span
              ></strong
            ><strong
              ><span 
                >イベント説明</span
              ></strong
            ><strong></strong>
          </p>
          <p >
            <strong
              ><span 
                >&nbsp;</span
              ></strong
            >
          </p>
          <p>
            <span >１</span
            ><span >．</span
            ><span>達成条件</span
            ><strong></strong>
          </p>
          <p >
            <span>1</span
            ><span>）</span
            ><span 
              >イベント参加時間内に、参加プレイヤーが所属サーバーにて</span
            ><span>「</span
            ><span
              >黄金城争覇戦第一位</span
            ><span>」</span
            ><span 
              >を達成したことによって、ゲーム内専用称号、実物の金インゴットとオリジナル限定印鑑の賞品を獲得できます。（状況により、賞品は金インゴットとオリジナル限定印鑑の同じ価値の物あるいは現金に<span>変更する</span
              >場合<span>があります</span>。</span
            ><span>予めご了承ください</span><span>。</span
            ><span>）</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2.</span>
            <span>説明</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>1</span
            ><span>）「</span
            ><span
              >黄金城争覇戦第一位</span
            ><span
              >」とは：『最強三国～黄金城の決戦』が正式リリース時点にオプする</span
            ><span>1-23</span
            ><span
              >サーバー（イベントサーバー）で、</span
            ><span>イベント終了</span
            ><span
              >まで戦績ランキングが一位になることです。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2</span
            ><span
              >）参加プレイヤーが「</span
            ><span
              >黄金城争覇戦第一位</span
            ><span>」</span
            ><span
              >を獲得したが、参加資格</span
            ><span>・</span
            ><span>賞品受領</span
            ><span
              >の条件を満たさない場合、賞品の</span
            ><span>受取資格</span
            ><span>は</span
            ><span
              >戦績ランキングの</span
            ><span 
              >順位に繰り下げられま</span
            ><span>せん。</span
            ><strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                ><br />
                <br /> </span
            ></strong>
          </p>
          <p>
            <strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                >3</span
              ></strong
            ><strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                >）不当景品類及び不当表示防止法の制限により、賞品を受けとるためには、参加プレイヤーがイベント期間中に</span
              ></strong
            ><strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                >3</span
              ></strong
            ><strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                >,000</span
              ></strong
            ><strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                >円以上の有料アイテムを購入する必要があります。</span
              ></strong
            ><strong></strong>
          </p>
          <p>
            &nbsp;
          </p>
          <p>
            4）参加プレイヤーが複数のイベントサーバーで「黄金城争覇戦第一位」を達成した場合、限定実物賞品1セット（実物の金インゴットとオリジナル限定印鑑）のみ受け取れます。賞品の受取資格は戦績ランキングの順位に繰り下げられません。
          </p>
          <p>
            <strong
              ><span
                >&nbsp;</span
              ></strong
            >
          </p>
          <p>
            <strong
              ><span
                ><span>四、</span></span
              ></strong
            ><strong
              ><span
                >賞品受領</span
              ></strong
            ><strong></strong>
          </p>
          <p>
            <strong
              ><span
                >&nbsp;</span
              ></strong
            >
          </p>
          <p>
            <span
              ><span
                >1.<span style="font:9px &#39;Times New Roman&#39;"
                  >&nbsp;
                </span></span
              ></span
            ><span
              >賞品受領の手続き</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              > 賞品受領資格の確認終了次第、主催者の専任スタッフからご連絡致しますので、賞品受領が確定した参加プレイヤーは下記情報をご用意ください。主催者は適切且つ安全に賞品受領者の個人情報を管理するとともに、イベント及び賞品の発送以外の目的に使用しません。個人情報の処理につきましては、主催者のプライバシーポリシーが適用されます。</span
            >
          </p>
          <p>
            <span 
              >①賞品受領者の氏名</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >②本人確認書類と身分証明書</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >③電子メールアドレス</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >④連絡先情報（郵便番号、電話番号、住所など）</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >⑤ゲームアカウントの</span
            ><span>Uid</span
            ><span>、サーバー</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >⑥他に必要な情報</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2</span
            ><span
              >．賞品受領に関する規約</span
            >
          </p>
          <p>
            <span>1</span
            ><span
              >）今回のイベントでの賞品受領により発生するし納付すべき諸々の税金や公租公課などは、受取人ご本人様が法律に則り、申告・納付するものとします。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2</span
            ><span
              >）<strong
                ><span style="color: red"
                  >結果発表後、専任のスタッフが受取人本人とコンタクトを取り、賞品の支払手続きを完了させます。</span
                ></strong
              ></span
            ><strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                >主催者が</span
              ></strong
            ><strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                >7</span
              ></strong
            ><strong
              ><span style=";font-family:&#39;MS Mincho&#39;;color:red"
                >営業日以内に賞品受領者と連絡が取れない場合、賞品受領者が</span
              ></strong
            ><strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                >受領資格を放棄することを見なします。</span
              ></strong
            ><span 
              >主催者は受取人が提供した情報に基づき賞品を支払いますので、必ず正確な情報をお知らせ下さい。提供された情報に問題があり、送金ができない場合は、賞品受領資格は取り消されます。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>3</span
            ><span
              >）賞品は受取人が提出した実名情報に基づき支払われるものとし、参加プレイヤーは、賞品受取資格を第三者に譲渡するなどの取引をすることはできません。賞品受領資格の取引事例が発生した場合、主催者は関係者全員の受取資格を取り消す権利を保有し、支払い済みの賞品の返還を求めます。この時、返還に必要な費用</span
            ><span>(</span
            ><span 
              >調査費用、弁護士費用、訴訟費用などが含まれるが、これらに限りません</span
            ><span>)</span
            ><span 
              >は、当該受取人が負担するものとします。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>4</span
            ><span
              >）本イベントに参加したプレイヤーが、本イベントルール、利用規約または関連法規に違反した場合、主催者は、当該プレイヤーの参加資格及び賞品受領資格を取り消す権利を保有します。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>5</span
            ><span
              >）賞品受領資格を得た参加プレイヤーは、主催者の求めに従い、定められた期間内に賞品の支払いに必要な情報を提出する必要があります。必要情報を提出しなかった場合、主催者は賞品の発送を延期することができ、それでも提出しない場合または、最終的に取り消す権利を保有します。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <strong
              ><span
                ><span>五、</span></span
              ></strong
            ><strong
              ><span
                >イベントルール</span
              ></strong
            ><strong></strong>
          </p>
          <p>
            <strong
              ><span
                >&nbsp;</span
              ></strong
            >
          </p>
          <p>
            <span>1</span
            ><span>.</span
            ><span>基本ルール</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>1</span
            ><span
              >）参加プレイヤーは、本イベントに参加した時点で、主催者が設けた一切のルールを了承するものと見なします。主催者は状況によってルールを修正及び変更する権利を保有します。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2</span
            ><span
              >）全てのルール及び日程、賞品にかかわる最終決定権は、主催者に属します。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>3</span
            ><span
              >）全てのルールにかかわる最終解釈権は、主催者に属します。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>4</span
            ><span
              >）主催者は参加プレイヤーに対し、如何なる課金行為も強制しません。イベント中参加プレイヤーの行った課金行為は、全て参加プレイヤーの自発的行為とみなします。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>5</span
            ><span
              >）本イベントの内容は予告なく変更または中止される可能性があります。この場合、主催者は一切の責任を負いません。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2</span
            ><span>.</span
            ><span 
              >不正行為及び規約違反に対する処理</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>1</span
            ><span
              >）主催者は公平性と完全性を害する行為に対し、処罰を行うことがあります。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2</span
            ><span
              >）本イベントに参加するプレイヤーの規約に違反する行為や不正行為は禁じられています。参加プレイヤーがこのルールに違反した場合、または、違法行為をした場合は、関係者全員のイベント参加資格及び関係する全ての賞品受領資格を取り消します。同時に、関係者全員のログイン制限、キャラクター凍結、ゲーム内アイテム没収等の処罰を行います。規約違反行為は以下のものを含みますが、これらに限りません。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span >①</span
            ><span 
              >ゲームのデータを書き直したり、または、ほかの補助用ソフトやシステムの故障を利用したりする行為；</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >②主催者の認可を得ていない方法によりアイテムを獲得したり、または、ゲーム開発者がまだ正式に発表していないアイテムを使用したりする行為；</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >③イベントを妨害し、ゲームの正常な運営を害する行為；</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >④不適切、不合理な手段を用い、ほかの参加プレイヤーを妨害する行為、または、不当な手段でゲームの勝敗を操る行為；</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span 
              >⑤その他イベントの公平性を害する行為</span
            ><span 
              ><br />
              <br />
            </span>
          </p>
          <p>
            <strong
              ><span 
                >六、お問い合わせ及び突発事象に関する処理</span
              ></strong
            ><strong></strong>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>1.</span
            ><span
              >お問い合わせ方法</span
            >
          </p>
          <p>
            <strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                > 本イベントに参加するプレイヤーは、イベントに関する問題がありましたら、</span
              ></strong
            ><strong
              ><span style="font-family:&#39;MS Mincho&#39;;color:red"
                >cs-skhg@guru-game.com</span
              ></strong
            ><strong
              ><span style="font-family: &#39;MS Mincho&#39;;color:red"
                >までお知らせください。</span
              ></strong
            ><span 
              >バグの重大性によっては、ゲームデータのリセットやイベントの一時中止等（これらに限りません）を含む、主催者が妥当と判断する措置を取ります。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2.</span
            ><span>バグ</span>
          </p>
          <p>
            <span 
              > イベント期間中にバグが発生した場合、参加プレイヤーはバグを悪用することはできません。主催者にはイベントの調整を行う権利があり、プレイヤーの皆様に状況をお知らせ致します。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>3.</span
            ><span>参加の準備</span>
          </p>
          <p>
            <span 
              > 参加プレイヤーの皆様は、イベントの開始までに、参加に必要な機器などの準備をご自身で行ってください。個人的な理由でゲーム進行に支障を来たしたり、失敗に終わったりした場合であっても、そのイベント結果を含むすべての責任は、プレイヤーご本人様が負うものとします。また、イベント中、参加プレイヤーの個人的な理由によりイベントが正常に続行できなくなった場合、その影響については、ご本人様が責任を負うものとします。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>4.</span
            ><span>不可抗力</span
            ><span><br /> </span
            ><span 
              > イベント中、不可抗力の影響が発生した場合は、主催者は本イベントに対する調整を行うことがあります。主催者は、不可抗力によりもたらされた損失には責任を負いません。不可抗力要素には以下のものが含まれますが、これに限るものではありません。インターネット設備の故障、コンピューターウィルス、ハッカー攻撃、自然災害、伝染病、法律及び法規の変更、その他予期できない人為的に避けられない客観的状況等。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>5. </span
            ><span>その他</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>1</span
            ><span
              >）主催者及び関連会社は、主催者の販促宣伝のために、イベントの様子を公開及び放映する権利を有します。主催者及び関連会社は、プレイヤーのニックネーム、イメージ等のデータを、イベントに向けての宣伝、生中継及びイベント後のリプレイのために、無期限及び無償で使用できます。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>2</span
            ><span
              >）参加プレイヤーは、本イベント「</span
            ><span>黄金城争覇戦</span
            ><span 
              >」の全てのゲーム記録に含まれるイベント写真、映像、録音等の素材の知的財産権及び各項の権利が、全て主催者とゲーム開発者に属することに同意し、主催者及び関連会社がこれらの素材を使用することにも同意することとします。</span
            >
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span>6.</span
            ><span> 雑則</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            <span> 本イベント規約の準拠法は日本法とします。本イベントに関係する紛争は、東京地方裁判所</span><span>/</span
            ><span>東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</span
            >
          </p>
        </span>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    components: {},
    name: "gold",
    data() {
      return {};
    },
    created() {
    },
    mounted() {},
    //methods中定义事件
    methods: {},
  };
</script>

<style lang="less" scoped>
  .content {
    width: 100%;
    min-width: 1400px;
    height: 1080px;
    background: url("./assets/img/rule_bg.jpg") no-repeat center center;
  }
  .box_7 {
    width: 1400px;
    margin: 0 auto;
    overflow: hidden;
  }
  .text-group_2 {
    width: 665px;
    height: 515px;
    margin: 365px 0 0 578px;
    padding: 0 10px 0px 15px;
    box-sizing: border-box;
    overflow-y: scroll;
  }
  .paragraph_1 {
    overflow-wrap: break-word;
    color: rgba(204, 192, 178, 1);
    font-size: 16px;
    font-family: MS-Gothic;
    text-align: left;
    line-height: 26px;
    margin-left: 2px;
  }
  .paragraph_1 a {
    color: #b7764b;
  }

.text-group_2::-webkit-scrollbar  {
    width: 8px;
}//滚动条整体部分，可以设置宽度啥的

.text-group_2::-webkit-scrollbar-button  {
    
}//滚动条两端的按钮

.text-group_2::-webkit-scrollbar-track  {
}//外层轨道

.text-group_2::-webkit-scrollbar-track-piece  {
    background-color: #807c71;
    border-radius: 4px;
}//内层轨道，滚动条中间部分(除去)

.text-group_2::-webkit-scrollbar-thumb  {
    background-color: #dbd8d3;
    border-radius: 4px;
}//滚动条里面可以拖动的那个

.text-group_2::-webkit-scrollbar-corner  {
}//边角

.text-group_2::-webkit-resizer {

}//定义右下角拖动块的样式
</style>
  